// getInitialFormData — the initial/default form values for AddEventForm.
//
// Extracted VERBATIM from `components/AddEventForm.js` (the `useState` initial
// value for `formData`) as part of the behavior-preserving refactor (issue
// #240). The source initializes EVERY field for EVERY event type to an empty
// string in a single flat object (it is not computed per-type); this builder
// preserves that exactly — same keys, same empty-string defaults, same grouping.
//
// Returns a FRESH object on every call so the hook's initial state never shares
// a reference across mounts, matching the source's once-per-mount object literal.
//
// Does NOT read the clock: every default is a fixed empty string, so no `now`
// injection is required (the only `new Date(...)` in the source lives in the
// submit-time payload builder, not in these defaults).
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Build the initial form-data object for AddEventForm.
 *
 * @returns {Object} A fresh copy of the empty form values (all event types).
 */
export function getInitialFormData() {
  return {
    // Flight fields
    airline: '',
    flightNumber: '',
    departureAirport: '',
    arrivalAirport: '',
    departureDate: '',
    departureTime: '',
    arrivalDate: '',
    arrivalTime: '',
    confirmationCode: '',

    // Hotel fields
    name: '',
    address: '',
    checkInDate: '',
    checkOutDate: '',
    confirmationNumber: '',

    // Car rental fields
    company: '',
    carType: '',
    pickupLocation: '',
    returnLocation: '',
    pickupDate: '',
    returnDate: '',
    pickupTime: '',
    returnTime: '',
    carConfirmationNumber: '',

    // Dining fields
    reservationDate: '',
    reservationTime: '',
    partySize: '',
    diningConfirmationNumber: '',

    // Common fields
    notes: ''
  };
}

export default getInitialFormData;
